import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import LanguageContext from './LanguageContext';
import { aboutPageCopy } from './translations';

function About() {
  const { language } = useContext(LanguageContext);
  const copy = aboutPageCopy[language] || aboutPageCopy.English;
  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="about-header">
        <div className="container">
          <h1 className="about-title">{copy.pageTitle}</h1>
          <p className="about-subtitle">{copy.pageSubtitle}</p>
        </div>
        <div className="wave-divider-header"></div>
      </section>

      {/* Brand Essence Section */}
      <section className="brand-essence-section">
        <div className="container">
          <div className="essence-content">
            <h2 className="section-title">{copy.essenceTitle}</h2>
            {copy.essenceParagraphs.map((paragraph) => (
              <p key={paragraph} className="essence-text">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Visual Element */}
      <section className="visual-element-section">
        <div className="container">
          <div className="energy-visual">
            <div className="energy-glow"></div>
            <img 
              src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&h=600&fit=crop&auto=format" 
              alt="Energy flow and spiritual connection"
              className="energy-image"
            />
            <div className="visual-overlay"></div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="what-we-do-section">
        <div className="container">
          <h2 className="section-title">{copy.whatWeDoTitle}</h2>
          <div className="services-grid">
            {copy.whatWeDoCards.map((card) => (
              <div key={card.title} className="service-type-card">
                <div className="service-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 6v6l4 2"></path>
                  </svg>
                </div>
                <h3 className="service-type-title">{card.title}</h3>
                <p className="service-type-description">{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How Sessions Are Delivered */}
      <section className="delivery-section">
        <div className="container">
          <h2 className="section-title">{copy.deliveryTitle}</h2>
          <div className="delivery-grid">
            <div className="delivery-card">
              <div className="delivery-indicator remote-indicator">
                <div className="indicator-dot"></div>
                <span>{copy.remoteIndicator}</span>
              </div>
              <h3 className="delivery-title">{copy.remoteTitle}</h3>
              <p className="delivery-description">{copy.remoteDescription}</p>
            </div>
            <div className="delivery-card">
              <div className="delivery-indicator oncall-indicator">
                <div className="indicator-dot"></div>
                <span>{copy.onCallIndicator}</span>
              </div>
              <h3 className="delivery-title">{copy.onCallTitle}</h3>
              <p className="delivery-description">{copy.onCallDescription}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy & Intention Section */}
      <section className="philosophy-section">
        <div className="container">
          <h2 className="section-title">{copy.philosophyTitle}</h2>
          <div className="philosophy-content">
            {copy.philosophyCards.map((card) => (
              <div key={card.title} className="philosophy-card">
                <div className="philosophy-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 6v6l4 2"></path>
                  </svg>
                </div>
                <h3 className="philosophy-title">{card.title}</h3>
                <p className="philosophy-text">{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="about-cta-section">
        <div className="container">
          <h2 className="cta-title">{copy.ctaTitle}</h2>
          <p className="cta-subtitle">{copy.ctaSubtitle}</p>
          <Link to="/services" className="btn-explore-services">
            {copy.ctaButton}
          </Link>
        </div>
      </section>

      {/* Contact Information */}
      <section className="contact-section">
        <div className="container">
          <h2 className="section-title">Contact Us</h2>
          <p style={{ fontSize: '1.2rem', color: '#E0E7FF', textAlign: 'center' }}>
            <a href="tel:+447356083797" style={{ color: '#C084FC', textDecoration: 'none' }}>
              +447356083797
            </a>
          </p>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer-section">
        <div className="container">
          <div className="footer-content" style={{ textAlign: 'center' }}>
            <div className="footer-column">
              <p style={{ color: '#C7D2FE', marginBottom: '0.5rem' }}>Address: 1st Floor, 124 Cleveland Street, London W1T 6PG</p>
              <p style={{ color: '#C7D2FE', marginBottom: '0.5rem' }}>
                <a href="mailto:manawave@manawave.uk" style={{ color: '#C7D2FE', textDecoration: 'none' }}>manawave@manawave.uk</a>
              </p>
              <p style={{ color: '#C7D2FE', marginBottom: '0.5rem' }}>
                <a href="tel:+447356083797" style={{ color: '#C7D2FE', textDecoration: 'none' }}>+447356083797</a>
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>Copyright © 2026 ManaWave LTD All Rights Reserved</p>
          </div>
        </div>
      </footer>

      {/* Gentle Closure */}
      <footer className="about-footer">
        <div className="wave-closure"></div>
      </footer>
    </div>
  );
}

export default About;

